import React from 'react';
import { Link } from 'react-router-dom';
import './Landing.css';

function Landing() {
  return (
    <div className="landing-page">
      <header>
        <div className="container">
          <Link to="/" className="logo">Prelude</Link>
          <div className="header-buttons">
            <Link to="/portal" className="portal-link">Portal</Link>
            <a href="mailto:konnermacias@gmail.com?subject=Book a Demo" className="cta-button">Book a Demo</a>
          </div>
        </div>
      </header>

      <section className="hero">
        <div className="container">
          <h1>Stop Sending 750-Song Spreadsheets</h1>
          <p className="subtitle">
            Give your wedding clients a beautiful, interactive portal to listen, browse, and select their perfect music.
            No more YouTube links. No more messy email chains.
          </p>
          <a href="mailto:konnermacias@gmail.com?subject=Streamline My Bookings" className="cta-button">Streamline Your Bookings Today</a>
        </div>
      </section>

      <section className="demo">
        <div className="container">
          <h2>See It In Action (1 Min)</h2>
          <div className="video-container">
            <iframe
              src="https://www.youtube.com/embed/Ke6p7BcIS5s"
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>
        </div>
      </section>

      <section className="story">
        <div className="container">
          <div className="story-content">
            <div className="story-text">
              <h2>We Built the Tool We Wished We Had</h2>
              <p>When my wife and I were planning our own wedding, we were overwhelmed. Our string quartet gave us a PDF with over 750 songs to choose from.</p>
              <p>We spent <em>hours</em> bouncing between the list and YouTube, just trying to figure out what each song sounded like. It was frustrating and we weren't confident in our choices.</p>
              <p>So, I built this. A simple, elegant web portal that let us listen to samples and build our request list in one place. It turned a chore into a fun experience. Now, I'm offering that same "wow" factor to you and your clients.</p>
            </div>
            <div className="story-image">
              <img src="https://images.pexels.com/photos/313707/pexels-photo-313707.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1" alt="String quartet sheet music" />
            </div>
          </div>
        </div>
      </section>

      <section className="how-it-works">
        <div className="container">
          <h2>Simple for You, Seamless for Them</h2>
          <div className="steps">
            <div className="step">
              <div className="step-number">1</div>
              <h3>You Provide Your List</h3>
              <p>You give us your song catalog in a simple Google Sheet. We handle all the technical setup, domain, and hosting.</p>
            </div>
            <div className="step">
              <div className="step-number">2</div>
              <h3>Clients Listen & Choose</h3>
              <p>Your clients get a private, branded website to listen to samples and add their favorites to a "request list" with one click.</p>
            </div>
            <div className="step">
              <div className="step-number">3</div>
              <h3>You Get the Final Picks</h3>
              <p>You get a clean, organized list of their selections in your vendor hub. No more messy emails or last-minute confusion.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="features">
        <div className="container">
          <h2>What You Get</h2>
          <div className="features-grid">
            <div className="feature-item">
              <h3>Your Own Branded Portal</h3>
              <p>A professional website with your logo and colors. You can even link it directly from your main site.</p>
            </div>
            <div className="feature-item">
              <h3>Interactive Music Player</h3>
              <p>Lets clients listen to samples (from YouTube or your own files) without ever leaving the page.</p>
            </div>
            <div className="feature-item">
              <h3>Client Request Hub</h3>
              <p>A central dashboard for you to track all your clients' song requests in one organized place.</p>
            </div>
            <div className="feature-item">
              <h3>Simple Google Sheet Management</h3>
              <p>Want to add or remove a song? Just update one Google Sheet, and your client portal updates automatically.</p>
            </div>
            <div className="feature-item">
              <h3>One-Time Setup Fee</h3>
              <p>We handle all the integration, engineering, domain, and hosting for a simple one-time payment.</p>
            </div>
            <div className="feature-item">
              <h3>Happier Clients, Less Admin</h3>
              <p>Give your clients a premium, confident experience and save yourself hours of administrative work.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="final-cta">
        <div className="container">
          <h2>Ready to Impress Your Next Client?</h2>
          <p>Let's schedule a quick, 10-minute call to show you a live demo and discuss how we can build your portal.</p>
          <a href="mailto:konnermacias@gmail.com?subject=Book Free Demo" className="cta-button">Book Your Free 10-Minute Demo</a>
        </div>
      </section>

      <footer>
        <div className="container">
          <p>&copy; 2025 Prelude. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
}

export default Landing;
